/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useState} from 'react'
import {KTSVG} from '../../../helpers'
import {useNavigate} from "react-router-dom";
import {CreateAppModal} from '../../../partials'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'
import {useUserroles} from '../../../../Atom/contextProviders/Atomqueryprovider'
import {useAuth} from '../../../../app/modules/auth';
import { useDashboard } from '../../../../Atom/contextProviders/Dashboardcontext';


const Toolbar1 = () => {
  const {classes} = useLayout()
  const {currentUser} = useAuth()
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const { showDashboard, toggleDashboard } = useDashboard();
  const navigate = useNavigate()

  // Roles hook
  const {
    isSuccess: userrolessuccess,
    data: userrolesdata,
  } = useUserroles(Number(currentUser?.user_role_id))

  const gotoProducts = () => {
    let path = `/viewproducts`
    navigate(path)
  }

  const isUserAdmin = () => {
    if (!userrolessuccess || !userrolesdata?.data) return false
    return (
      userrolesdata.data.role_name === 'Admin' ||
      userrolesdata.data.is_admin === true
    )
  }

  const handleButtonClick = () => {
    if (isUserAdmin()) {
      gotoProducts()
    }
  }

  
  return (
    <>
      <div className='toolbar' id='kt_toolbar'>
        {/* begin::Container */}
        <div
          id='kt_toolbar_container'
          className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack flex-wrap')}
        >
          {/* begin::Title - Allow it to shrink on small screens */}
          <div className="flex-shrink-1 me-2">
            <DefaultTitle />
          </div>
          {/* end::Title */}

          {/* begin::Actions - Always stay on the right */}
          <div className='d-flex align-items-center py-1 flex-shrink-0'>
            {/* begin::Dashboard Toggle Switch */}
            <div className="form-check form-switch me-2 d-flex align-items-center">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={showDashboard}
                onChange={toggleDashboard}
                style={{cursor: 'pointer'}}
              />
              {/* Hide text on very small screens */}
              <span className="ms-2 fw-bold text-uppercase d-none d-sm-inline" style={{fontSize: '11px'}}>
                {showDashboard ? 'HIDE CHARTS' : 'SHOW CHARTS'}
              </span>
              {/* Show abbreviated text on extra small screens */}
              <span className="ms-2 fw-bold text-uppercase d-sm-none" style={{fontSize: '10px'}}>
                {showDashboard ? 'HIDE' : 'SHOW'}
              </span>
            </div>
            {/* end::Dashboard Toggle Switch */}

            {/* begin::Divider */}
            <span className="h-30px border-gray-200 border-start me-2"></span>
            {/* end::Divider */}

            {/* begin::Stock Button */}
            <button
              className={clsx(
                'btn btn-sm btn-primary',
                !isUserAdmin() && 'disabled'
              )}
              id='kt_toolbar_primary_button'
              onClick={handleButtonClick}
              disabled={!isUserAdmin()}
              style={{
                cursor: !isUserAdmin() ? 'not-allowed' : 'pointer',
                opacity: !isUserAdmin() ? 0.6 : 1,
              }}
            >
              <KTSVG
                path='/media/icons/duotune/ecommerce/ecm006.svg'
                className='svg-icon-2'
              />
              {/* Show full text on medium+ screens */}
              <span className="d-none d-md-inline ms-1">View Current Stock</span>
              {/* Show abbreviated text on small screens */}
              <span className="d-md-none ms-1">Stock</span>
            </button>
            {/* end::Stock Button */}
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Container */}
      </div>

      <CreateAppModal
        show={showCreateAppModal}
        handleClose={() => setShowCreateAppModal(false)}
      />
    </>
  )
}

export {Toolbar1}